<template>
  <div class="pagination w-full p-4">
    <div class="item special" v-show="internalPage > 1" @click="changePage(1)">
      <eva-icon name="arrowhead-left-outline" height="16" />
    </div>
    <div
      class="item special"
      v-show="internalPage > 1"
      @click="changePage(internalPage - 1)"
    >
      <eva-icon name="arrow-ios-back-outline" height="16" />
    </div>
    <div class="item border-0" v-show="internalPage - showPages > 1">...</div>
    <div
      :class="i == internalPage ? 'item active' : 'item'"
      v-for="i in lastPage"
      :key="`pagination_item_${i}`"
      v-show="i >= internalPage - showPages && i <= internalPage + showPages"
      @click="changePage(i)"
    >
      {{ i }}
    </div>
    <div class="item border-0" v-show="internalPage + showPages < lastPage">
      ...
    </div>
    <div
      class="item special"
      v-show="internalPage < lastPage"
      @click="changePage(internalPage + 1)"
    >
      <eva-icon name="arrow-ios-forward-outline" height="16" />
    </div>
    <div
      class="item special"
      v-show="internalPage < lastPage"
      @click="changePage(lastPage)"
    >
      <eva-icon name="arrowhead-right-outline" height="16" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    lastPage: Number,
    currentPage: {
      type: Number,
      default: 1,
    },
    showPages: {
      type: Number,
      default: 2,
    },
  },
  data: function () {
    return {
      internalPage: this.currentPage,
    };
  },
  methods: {
    changePage(page) {
      this.internalPage = page;
      this.$emit("changePage", page);
      
      const query = { ...this.$route.query, page: page };
      this.$router.replace({ query });
    },
  },
};
</script>

<style lang="scss">
.pagination {
  display: flex;
  justify-content: center;

  .item {
    display: inline-block;
    margin: 0px 5px;
    height: 35px;
    min-width: 35px;
    text-align: center;
    line-height: 30px;
    border: 1.5px solid #c4c5d0;
    color: #808198;
    fill: #808198;
    border-radius: 10px;
    font-size: 16px;

    &.active {
      border-color: #ff7913;
      background: #ff7913;
      color: white;
      fill: white;
    }

    &.special {
      line-height: 37px;
    }
    &.border-0 {
      border: 0px !important;
    }
  }
}
</style>
